import apiInvoice from "../config/api_invoice";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiInvoice = axios.create({
//   baseURL: "http://localhost:8072",
//   headers: getHeaders(),
// });

export function downloadInvoiceFile({ groupId, farmId, invoiceId }) {
  return apiInvoice.get(
    `/bovexo/${groupId}/farms/${farmId}/invoices/${invoiceId}/download`,
    getHeaders(false, null, true),
  );
}

export function callStoreInvoice(payload) {
  const { groupId, farmId, file, parsedData } = payload;

  let formData = new FormData();
  formData.append("file", file);
  formData.append("request", JSON.stringify(parsedData));

  return apiInvoice.post(
    `/bovexo/${groupId}/farms/${farmId}/invoices`,
    formData,
    getHeaders(true),
  );
}

export function parseInvoiceAutoDetect(payload) {
  const { file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiInvoice.post("/bovexo/invoices/parse", formData, getHeaders(true));
}

export function parseNfeXml(payload) {
  const { file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiInvoice.post(
    "/bovexo/invoices/parse/nfe/xml",
    formData,
    getHeaders(true),
  );
}

export function parseNfeDanfePdf(payload) {
  const { file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiInvoice.post(
    "/bovexo/invoices/parse/nfe/pdf",
    formData,
    getHeaders(true),
  );
}

export function parseNfseXml(payload) {
  const { file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiInvoice.post(
    "/bovexo/invoices/parse/nfse/xml",
    formData,
    getHeaders(true),
  );
}

export function parseNfsePdf(payload) {
  const { file } = payload;

  let formData = new FormData();
  formData.append("file", file);

  return apiInvoice.post(
    "/bovexo/invoices/parse/nfse/pdf",
    formData,
    getHeaders(true),
  );
}

export function callGetInvoiceById(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiInvoice.get(
    `/bovexo/${groupId}/farms/${farmId}/invoices/${id}`,
    getHeaders(false, signal),
  );
}
